export default "__VITE_ASSET__0220c1dd__"